module.exports = __webpack_public_path__ + "static/media/NoImageAvailable.5cdcfdb8.png";